import React, { useState, useEffect  } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import useHeaders from "../../../helpers/useHeaders";
import Checkbox from '@mui/material/Checkbox';
import { visuallyHidden } from '@mui/utils';
import profileimgs from "../../../assets/images/profile.png";
import useEncryption from '../../../services/useEncryption';
import path from '../../../path';
import { getAllTeamApi } from '../../../api/userApi/userApi';
import EditTeamModal from './EditTeamModal';
import useToast from "../../../helpers/useToast";
import { toast } from "react-toastify";
import { deleteTeamApi } from '../../../api/userApi/userApi';
import DeleteDialogBox from '../../../components/dialogBox/DeleteDialogBox';
import { useParams, useOutletContext } from "react-router-dom";
import ViewTeamModal from './ViewTeamModal';

import CloseIcon from '@mui/icons-material/Close';

import "./allpages.css";
import { createAuditLogs } from '../../../api/providerApi/providerApi';
import { useSelector } from 'react-redux';
import { selectAuth } from '../../../redux/slice/authSlice';
import { resendTeamMail } from '../../../api/adminApi/adminApi';




function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'firstName',
        numeric: true,
        disablePadding: true,
        label: 'Team Member Name',
    },
    {
        id: 'phoneNumber',
        numeric: true,
        disablePadding: false,
        label: 'Phone',
    },
    {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'Email',
    },
    {
        id: 'role',
        numeric: true,
        disablePadding: false,
        label: 'User Type',
    },
    {
        id: 'organizationName',
        numeric: true,
        disablePadding: false,
        label: 'Location',
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
    },
    {
        id: 'actions',
        numeric: true,
        disablePadding: false,
        label: 'Actions',
    },

];

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        // align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (<></>
        // <Toolbar
        //     sx={{
        //         pl: { sm: 2 },
        //         pr: { xs: 1, sm: 1 },
        //         ...(numSelected > 0 && {
        //             bgcolor: (theme) =>
        //                 alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        //         }),
        //     }}
        // >
        //     {numSelected > 0 ? (
        //         <Typography
        //             sx={{ flex: '1 1 100%' }}
        //             color="inherit"
        //             variant="subtitle1"
        //             component="div"
        //         >
        //             {numSelected} selected
        //         </Typography>
        //     ) : (
        //         <Typography
        //             sx={{ flex: '1 1 100%' }}
        //             variant="h6"
        //             id="tableTitle"
        //             component="div"
        //         >
        //             Nutrition
        //         </Typography>
        //     )}

        //     {numSelected > 0 ? (
        //         <Tooltip title="Delete">
        //             <IconButton>
        //                 <DeleteIcon />
        //             </IconButton>
        //         </Tooltip>
        //     ) : (
        //         <Tooltip title="Filter list">
        //             <IconButton>
        //                 <FilterListIcon />
        //             </IconButton>
        //         </Tooltip>
        //     )}
        // </Toolbar>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};




export const Managestafftable = ({search, update, setUpdate}) => {
    const toastOptions = useToast();
    const headers = useHeaders();
    const [order, setOrder] = React.useState('desc');
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [isViewOpen, setIsViewOpen] = useState(false);
    const [loading, setLoading] = useOutletContext();
    const [orderBy, setOrderBy] = React.useState('created_at');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rows , setRows] = useState([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const { encryptData, decryptData } = useEncryption();
    const { id } =useParams();
    const [totalTeams, setTotalTeams] = useState(0);
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const decryptedId = decryptData(decodeURIComponent(id));
    const [teamToDelete, setTeamToDelete] = useState(null);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false); 
    const { role } = useSelector(selectAuth);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    // const emptyRows =
    //     page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
    const emptyRows = rows?.length ==  0;

    const visibleRows = React.useMemo(
        () =>
            stableSort(rows, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage],
    );



    useEffect(() => {
        fetchData();
    }, [page, rowsPerPage, order, orderBy, search, update ]);

    const fetchData = async () => {

        try {
            setLoading(true);
            const response = await getAllTeamApi(decryptedId, page, rowsPerPage, orderBy, order, search)
            const decryptedData = decryptData(response?.data?.data);
            setRows(decryptedData?.teams);
            setTotalTeams(decryptedData?.totalTeams);
            setTotalPages(decryptedData?.totalPages);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    };

    const [age, setAge] = React.useState('');
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setSelectedTeam(null);
        setIsEditOpen(false);
        setIsViewOpen(false);
    };
    const [profilePic, setProfilePic] = useState(null); 

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfilePic(reader.result); 
            };
            reader.readAsDataURL(file); 
        }
    };

    const triggerFileUpload = () => {
        document.getElementById('file-upload').click();
    };

    const handleEditOpen = (team) => {
        setSelectedTeam(team);
        setIsEditOpen(true);
    };


    const handleViewOpen = (team) => {
        setSelectedTeam(team);
        setIsViewOpen(true);
    };

    const handleDeleteClick = (teamId,  isPrimary) => {
        if(isPrimary){
            toast.error("Deleting the primary user is not allowed.")
            return;
        }
        setTeamToDelete(teamId);
        setIsDeleteOpen(true);
      };


  const handleDeleteClose = () => {
    setIsDeleteOpen(false); 
    setTeamToDelete(null);
  };

  const handleDelete = async () => {
    try {
        const response = await deleteTeamApi(teamToDelete, headers);
        toast.success(response.data.message,toastOptions);
        setUpdate(prev => !prev);
        let row = rows.filter((i)=> i._id === teamToDelete);
        let obj = {
            event : `${role} has deleted ${row[0].firstName} ${row[0].lastName} in teams.`
          }
        await createAuditLogs({ data: encryptData(obj)}, headers);
        setIsDeleteOpen(false);
    } catch (error) {
        toast.error(error.response.data.message, toastOptions);
    }
  };

  const handleResendMail = async(id)=>{
    try {
      let mailSent = await resendTeamMail(id, headers);
      toast.success(mailSent.data.message);
    } catch (error) {
        toast.error(error.response.data.message, toastOptions);
    }
  }

    return (
        <div className='tableDesigned'>
            <Box>
                <Paper>
                    <EnhancedTableToolbar numSelected={selected.length} />
                    <TableContainer>
                        <Table>
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={totalTeams}
                            />
                            <TableBody>
                                {rows.map((row, index) => {
                                    const isItemSelected = isSelected(row?._id);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row?._id}
                                            selected={isItemSelected}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    onClick={(event) => handleClick(event, row?._id)}
                                                    color="primary"
                                                    checked={isItemSelected}
                                                    inputProps={{
                                                        'aria-labelledby': labelId,
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                            >
                                                <div className="d-flex align-items-center">
                                                    <div className="profilepic"> 
                                                    <img 
                                                      src={row?.photo ? `${path}/${row?.photo.replace("public/images/UserIcons/", "")}` : profileimgs} 
                                                      alt={row?.photo ? `${row?.firstName} ${row?.lastName}` : "profileimg"} 
                                                    />
                                                    </div>
                                                    {row?.firstName} {row?.lastName}
                                                </div>

                                            </TableCell>
                                            <TableCell>{row?.phoneNumber}</TableCell>
                                            <TableCell >{row?.email}</TableCell>
                                            <TableCell >
                                            {row?.role === "location" 
                                            ? "Admin" 
                                            : row?.role.charAt(0).toUpperCase() + row?.role.slice(1)}
                                            </TableCell>
                                            <TableCell>{row?.organizationName}</TableCell>
                                            <TableCell>{row?.status}</TableCell>
                                            <TableCell >
                                                <div className="btn-groups">
                                                    <button onClick={() => handleViewOpen(row)} className='actionbuttons'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M20.4908 11.1432C20.8361 11.6696 20.8361 12.3304 20.4908 12.8568C19.4032 14.5146 16.5729 18 11.9999 18C7.4269 18 4.5966 14.5146 3.50898 12.8568C3.16367 12.3304 3.16367 11.6696 3.50898 11.1432C4.5966 9.48535 7.4269 6 11.9999 6C16.5729 6 19.4032 9.48535 20.4908 11.1432Z" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                                        <path d="M15 12C15 13.6569 13.6568 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6568 9 15 10.3431 15 12Z" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                                    </svg></button>
                                                    <button onClick={() => handleEditOpen(row)} className='actionbuttons'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                        <path d="M3.99939 21.4801H20.499M19.2362 4.39438L20.0851 5.24337C20.8662 6.02442 20.8662 7.29075 20.0851 8.0718L8.84933 19.3076C8.62978 19.5271 8.36213 19.6926 8.06758 19.7907L3.94804 21.1639C3.55716 21.2942 3.18529 20.9223 3.31558 20.5315L4.68876 16.4119C4.78695 16.1174 4.95237 15.8497 5.17192 15.6302L16.4077 4.39437C17.1888 3.61333 18.4551 3.61333 19.2362 4.39438Z" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                                    </svg></button>
                                                    <button onClick={() => handleDeleteClick(row._id, row?.isPrimaryTrue)}className='actionbuttons'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                        <path d="M18 7.48047H18.5C19.0523 7.48047 19.5 7.03275 19.5 6.48047V5.98047C19.5 5.42819 19.0523 4.98047 18.5 4.98047H15.5M18 7.48047V19.4805C18 20.5851 17.1046 21.4805 16 21.4805H8C6.89543 21.4805 6 20.5851 6 19.4805V7.48047M18 7.48047H6M15.5 4.98047V4.48047C15.5 3.3759 14.6046 2.48047 13.5 2.48047H10.5C9.39543 2.48047 8.5 3.3759 8.5 4.48047V4.98047M15.5 4.98047H8.5M6 7.48047H5.5C4.94772 7.48047 4.5 7.03275 4.5 6.48047V5.98047C4.5 5.42819 4.94772 4.98047 5.5 4.98047H8.5M10 10.9805V17.9805M14 10.9805V17.9805" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                                    </svg></button>
                                                    <button className="actionbuttons" onClick={() => handleResendMail(row._id)} disabled={row?.status === 'active'}>
                                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M4.98242 6.35107L11.09 10.9633L11.0921 10.965C11.7702 11.4623 12.1095 11.7111 12.4812 11.8072C12.8096 11.8922 13.1549 11.8922 13.4834 11.8072C13.8553 11.711 14.1956 11.4615 14.875 10.9633C14.875 10.9633 18.7925 7.95701 20.9824 6.35107M3.98242 16.1512V8.55127C3.98242 7.43116 3.98242 6.87069 4.20041 6.44287C4.39215 6.06654 4.69789 5.7608 5.07422 5.56906C5.50204 5.35107 6.06251 5.35107 7.18262 5.35107H18.7826C19.9027 5.35107 20.462 5.35107 20.8898 5.56906C21.2661 5.7608 21.5729 6.06654 21.7646 6.44287C21.9824 6.87027 21.9824 7.43006 21.9824 8.54798V16.1546C21.9824 17.2725 21.9824 17.8315 21.7646 18.2589C21.5729 18.6352 21.2661 18.9415 20.8898 19.1332C20.4624 19.351 19.9034 19.351 18.7855 19.351H7.17933C6.06141 19.351 5.50162 19.351 5.07422 19.1332C4.69789 18.9415 4.39215 18.6352 4.20041 18.2589C3.98242 17.8311 3.98242 17.2713 3.98242 16.1512Z" stroke="#241C1E" stroke-linecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </TableCell>

                                        </TableRow>
                                    );
                                })}
                                {emptyRows  && (
                                    <TableRow
                                        style={{
                                            height: (dense ? 33 : 53) * emptyRows,
                                        }}
                                    >
                                        
                                        <TableCell colSpan={7} className='norecord'>No Record Found</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalTeams}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </Box>
            
            <DeleteDialogBox
              isDeleteOpen={isDeleteOpen}
              onDeleteClose={handleDeleteClose} 
              onConfirm={handleDelete} 
              title="Confirm Deletion"
              description="Are you sure you want to delete this team member?"
            />
            <ViewTeamModal 
                isViewOpen={isViewOpen} 
                handleClose={handleClose}  
                selectedTeam={selectedTeam} 
                onEditClick={() => {
                    setIsViewOpen(false);
                    setIsEditOpen(true)
                }} 
            />
            <EditTeamModal isEditOpen={isEditOpen} handleClose={handleClose} setUpdate={setUpdate} selectedTeam={selectedTeam} />
        </div>
    );
}


